import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { Project } from '../project';

@JsonObject('model.activity.ActivityType')
export class ActivityOverlap extends AbstractModel {

    @JsonProperty(DateConverter, 'nearestAvailableTime')
    nearestAvailableTime?: Date;

    @JsonProperty(Boolean, 'overlapping')
    overlapping?: boolean;

    @JsonProperty(String, 'projectName')
    projectName?: string;

    @JsonProperty(Number, 'projectId')
    projectId?: number;
}